<template>
  <div class="page-container" data-test="main-holder">
    <Header></Header>
    <router-view />
    <Footer></Footer>
  </div>
</template>

<script setup lang="ts">
import Header from "@/layout/Header.vue";
import Footer from "@/layout/Footer.vue";
import { rumInit } from "@/config/rumConfig";

//Real User Monitoring - https://docs.mop.maersk.io/rum/index.html
rumInit();
</script>

<style scoped lang="scss">
.page-container {
  position: relative;
  margin: 0;
  max-width: 100%;
}
</style>
